import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';
import { Brand } from 'src/app/domain/models/funnel/brand-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { SourceOfDomain } from 'src/app/domain/models/resources/source-of-domain-enum';
import { FunnelService } from 'src/app/infraestructure/drive-adapter/funnel-service/funnel.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-countdown',
  templateUrl: './header-countdown.component.html',
  styleUrls: ['./header-countdown.component.scss'],
})
export class HeaderCountdownComponent implements OnInit, OnDestroy {
  public FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] } };
  @Input() brandResources!: IBrandResources;
  private headerStylesSubscription!: Subscription;
  headerStyles: IHeaderStyles = {
    opacity: 1,
    logo: '',
    class: '',
  };
  public showClassVerify? = false;
  public countdown: number = 15 * 60;
  private countdownInterval: any;
  public environment = environment;

  constructor(
    private funnelService: FunnelService
  ) { }

  ngOnInit(): void {
    this.ListenStepChanged();
    if (this.headerStyles.logo == '' || this.headerStyles.logo == undefined) {
      this.headerStyles.logo = this.environment.assetsURL + this.brandResources?.pathLogoBlack!;
      if (this.brandResources.brand?.toString() == Brand[Brand.Financeify]) {
        this.headerStyles.logo = environment.assetsURL + this.brandResources.pathLogos + "/logo-black.webp"
      }
    }
    this.showClassVerify =
      this.brandResources?.domains &&
      this.brandResources?.domains?.some((domain: any) =>
        domain.includes(SourceOfDomain.VerifyFinancialProfile)
      );
    const savedCountdown = localStorage.getItem('countdown');
    this.countdown = savedCountdown
      ? parseInt(savedCountdown, 10)
      : this.countdown;
    this.startCountdown();
  }

  ngOnDestroy(): void {
    this.headerStylesSubscription?.unsubscribe();
    clearInterval(this.countdownInterval);
  }

  ListenStepChanged() {
    this.funnelService.GetUserRegister().subscribe((FunnelFlow: FunnelFlow) => {
      this.FunnelFlow = FunnelFlow;
    });
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        localStorage.setItem('countdown', this.countdown.toString());
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  getMinutes(): string {
    return Math.floor(this.countdown / 60)
      .toString()
      .padStart(2, '0');
  }

  getSeconds(): string {
    return (this.countdown % 60).toString().padStart(2, '0');
  }
}
